import findLast from 'lodash/findLast';

/*
 * Helper utility functions to get the item group title and total label
 * @param {object} groupData - the object provided by BOP located at `order.itemGroups`
 * @param {string} locale - locale of the current site
 */
export const getItemGroupTitle = (groupData, locale) => {
  const display = groupData.customOrderData?.display || {};
  const overrideConfig = display?.overrides || [];
  const localeOverrides = findLast(overrideConfig, override =>
    override.locales.includes(locale)
  );

  // title
  const overrideTitle = localeOverrides?.strings?.itemGroupTitle || null;
  const defaultDisplayTitle = display.strings?.itemGroupTitle || null;

  return overrideTitle || defaultDisplayTitle || undefined;
};

export const getItemGroupTotalLabel = (groupData, locale) => {
  const display = groupData.customOrderData?.display || {};
  const overrideConfig = display?.overrides || [];
  const localeOverrides = findLast(overrideConfig, override =>
    override.locales.includes(locale)
  );

  // label
  const overrideTotalLabel =
    localeOverrides?.strings?.itemGroupTotalLabel || null;
  const defaultTotalLabel = display.strings?.itemGroupTotalLabel || null;

  return overrideTotalLabel || defaultTotalLabel || undefined;
};
